<template>
  <loading-spinner ref="spinner" spinnerType="border" color="primary" />
  <toast-notification ref="notification" />
  <site-modal
    ID="timesListModal"
    modalSize="semiMedium"
    :modalHasFooter="false"
    @Closed="closedTimesListModal"
    :modalClass="isSessionListModalShown ? 'hideModal' : 'showModal'"
  >
    <template #header>
      <div class="text-yellowTheme">
        <h6>
          <svg
            width="24px"
            height="24px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-clock-history"
            viewBox="0 0 16 16"
          >
            <path
              d="M8.515 1.019A7 7 0 0 0 8 1V0a8 8 0 0 1 .589.022l-.074.997zm2.004.45a7.003 7.003 0 0 0-.985-.299l.219-.976c.383.086.76.2 1.126.342l-.36.933zm1.37.71a7.01 7.01 0 0 0-.439-.27l.493-.87a8.025 8.025 0 0 1 .979.654l-.615.789a6.996 6.996 0 0 0-.418-.302zm1.834 1.79a6.99 6.99 0 0 0-.653-.796l.724-.69c.27.285.52.59.747.91l-.818.576zm.744 1.352a7.08 7.08 0 0 0-.214-.468l.893-.45a7.976 7.976 0 0 1 .45 1.088l-.95.313a7.023 7.023 0 0 0-.179-.483zm.53 2.507a6.991 6.991 0 0 0-.1-1.025l.985-.17c.067.386.106.778.116 1.17l-1 .025zm-.131 1.538c.033-.17.06-.339.081-.51l.993.123a7.957 7.957 0 0 1-.23 1.155l-.964-.267c.046-.165.086-.332.12-.501zm-.952 2.379c.184-.29.346-.594.486-.908l.914.405c-.16.36-.345.706-.555 1.038l-.845-.535zm-.964 1.205c.122-.122.239-.248.35-.378l.758.653a8.073 8.073 0 0 1-.401.432l-.707-.707z"
            ></path>
            <path
              d="M8 1a7 7 0 1 0 4.95 11.95l.707.707A8.001 8.001 0 1 1 8 0v1z"
            ></path>
            <path
              d="M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5z"
            ></path>
          </svg>
          تعیین زمان جلسه
        </h6>
      </div>
    </template>
    <template #body>
      <!-- {{ selectedCell.groupedTimeTable.length }} -->
      <div v-if="selectedCell.groupedTimeTable.length != 0">
        <div>
          <p v-if="!hasSessionToReplace()">
            بازه زمانی که انتخاب کرده اید به شرح زیر است:
            <!-- <template v-if="getBackRoutFrom() != 'selectTestSession'">
              بازه زمانی جلسه
              <b>{{
                entityObject.sessionTypeID == 1 ? 'حضوری' : 'غیرحضوری'
              }}</b>
              مورد نظر خود را انتخاب نمایید:
            </template>
            <template v-else>
              بازه زمانی مناسب برای انجام
              <b>{{
                entityObject.sessionTypeID == 1 ? 'حضوری' : 'غیرحضوری'
              }}</b>
              تست خود را انتخاب نمایید.
            </template> -->
          </p>
          <p v-else>
            به منظور
            <span class="fw-bold text-danger-gradient blinkText"
              >جابجایی جلسه</span
            >
            بازه زمانی جلسه
            <b>{{ entityObject.sessionTypeID == 1 ? 'حضوری' : 'غیرحضوری' }}</b>
            مورد نظر خود را انتخاب نمایید:
          </p>
        </div>

        <div class="pe-md-3 text-center">
          <div class="row">
            <div class="col-12 text-danger">
              <b
                >{{ selectedCell.dayName }}
                {{ getShiftByTimeType(selectedCell.timeType) }}
              </b>
              <b v-if="!this.$store.getters.isOverseas" class="px-1">
                {{ selectedCell.persianDate }}</b
              >
              <b
                class="gregorianDateClass px-1"
                v-if="this.$store.getters.isOverseas"
                style="unicode-bidi: embed"
              >
                {{ getGregorianDateOfSession(selectedCell.englishDate) }}
              </b>
            </div>
            <div class="col-md-7 col-12">
              <!-- <b>{{ selectedCell.persianDate }}</b> -->
            </div>
          </div>
          <div class="alert text-center alert-success mt-2 m-0">
            لطفا ساعت جلسه را انتخاب کنید:
          </div>
          <div class="">
            <!-- <div class="col-md-5 col-12">
              بازه زمانی: <b>{{ getShiftByTimeType(selectedCell.timeType) }}</b>
            </div> -->
            <!-- <div class="col-md-7 col-12" v-if="this.$store.getters.isOverseas">
              <b class="gregorianDateClass" style="unicode-bidi: embed">{{
                getGregorianDateOfSession(selectedCell.englishDate)
              }}</b>
            </div> -->
          </div>
        </div>
        <!-- <hr /> -->

        <div
          class="d-flex justify-content-center flex-wrap mt-3"
          style="gap: 20px"
        >
          <div
            class="card w-45"
            v-for="(item, index) in selectedCell.groupedTimeTable"
            :key="index"
            @click="
              getSessions(
                getFromTime(item),
                getToTime(item),
                selectedCell.englishDate,
                item
              )
            "
          >
            <ul class="list-group list-group-flush p-0">
              <li class="list-group-item text-center timeItem">
                از
                {{ getFromTime(item) }}
                تا
                {{ getToTime(item) }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div v-else>
        <p>هیچ بازه زمانی جهت نمایش و انجام فرآیند ثبت جلسه وجود ندارد.</p>
        <hr />
        <div class="text-center">
          <button
            class="btn btn-sm btn-outline-blueSite"
            @click="closedTimesListModal()"
          >
            <svg
              width="18px"
              height="18px"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              class="bi bi-check-lg"
              viewBox="0 0 16 16"
            >
              <path
                d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"
              ></path>
            </svg>
            تایید
          </button>
        </div>
      </div>
    </template>
    <template #footer>
      <div style="background-color: red; width: 100%; height: 100%"></div>
    </template>
  </site-modal>
  <site-modal
    ID="sessionsListModal"
    :modalSize="sessionsList.length == 0 ? 'small' : 'medium'"
    :modalHasFooter="false"
    :modalClass="isConfirmationModalShown ? 'hideModal' : 'showModal'"
    @Closed="closedSessionsListModal"
  >
    <template #header>
      <div class="text-yellowTheme">
        <h6>
          <svg
            width="18px"
            height="18px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-list-task"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M2 2.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H2zM3 3H2v1h1V3z"
            ></path>
            <path
              d="M5 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM5.5 7a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9zm0 4a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9z"
            ></path>
            <path
              fill-rule="evenodd"
              d="M1.5 7a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V7zM2 7h1v1H2V7zm0 3.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H2zm1 .5H2v1h1v-1z"
            ></path>
          </svg>
          {{
            entityObject.therapyTypeID == 14 ? 'جزئیات جلسه' : 'انتخاب درمانگر'
          }}
        </h6>
      </div>
    </template>
    <template #body>
      <div v-if="sessionsList.length != 0">
        <div
          v-if="isSessionListModalErrorShows"
          class="alert alert-danger"
          role="alert"
        >
          {{ sessionListModalErrorMessage }}
        </div>
        <div>
          <p
            class="mb-2"
            style="text-align: justify"
            v-if="entityObject.therapistStatus == 'dontCareTherapist'"
          >
            <!-- از میان پرتقاضاترین
            {{
              entityObject.therapyTypeID == 2 ? 'روانپزشک‌های' : 'درمانگر‌های'
            }}
            {{
              entityObject.therapyTypeID == 2
                ? 'کلینیک، براساس بازه زمانی شما، روانپزشک یا روانپزشک‌های زیر انتخاب شد.'
                : 'کلینیک، براساس بازه زمانی شما، درمانگر یا درمانگران زیر انتخاب شد.'
            }} -->
            <template v-if="sessionsList.length > 1">
              لطفا یکی‌ از گزینه‌های زیر را انتخاب نمایید:
            </template>
          </p>
          <p v-else>جزییات جلسه شما به شرح زیر است:</p>
          <!-- <div class="row">
            <div
              class="col-md-6 col-12 text-center"
              :class="isMobile ? 'fs-8' : ''"
            >
              تاریخ شمسی جلسه:<b>{{ selectedCell.persianDate }}</b>
            </div>
            <div
              class="col-md-6 col-12 text-center"
              :class="isMobile ? 'fs-8' : ''"
            >
              تاریخ میلادی جلسه:<b
                class="gregorianDateClass"
                style="unicode-bidi: embed"
                >{{ getGregorianDateOfSession(selectedCell.englishDate) }}</b
              >
            </div>
          </div> -->
        </div>
        <div>
          <template v-for="(session, index) in sessionsList" :key="index">
            <div class="card border-secondary text-dark m-2">
              <h5 class="card-header bg-lightsecondary">
                <div class="d-flex justify-content-between">
                  <div :class="isMobile ? 'fs-6' : ''">
                    درمانگر:
                    <b>{{ session.therapistName }} </b>
                  </div>
                </div>
              </h5>
              <div class="card-body">
                <div class="row m-auto text-right">
                  <div class="col-6">
                    <h6 :class="isMobile ? 'fs-8' : ''">
                      نوع درمان:
                      <b>{{ session.therapyTypeTitle }}</b>
                    </h6>
                  </div>

                  <div class="col-6">
                    <h6 :class="isMobile ? 'fs-8' : ''">
                      از ساعت:
                      <b>{{ getHourAndMinute(session.fromTime) }}</b>
                    </h6>
                  </div>
                  <div class="col-6">
                    <h6 :class="isMobile ? 'fs-8' : ''">
                      تا ساعت: <b>{{ getHourAndMinute(session.toTime) }}</b>
                    </h6>
                  </div>
                  <div class="col-6">
                    <h6 :class="isMobile ? 'fs-8' : ''">
                      نوع جلسه:
                      <b>{{
                        `${
                          entityObject.sessionTypeID == 2
                            ? 'غیر حضوری'
                            : 'حضوری'
                        }`
                      }}</b>
                    </h6>
                  </div>
                  <div class="col-md-12" v-if="!session.isCancelable">
                    <h6 :class="isMobile ? 'fs-8' : ''">
                      جلسه قابل لغو است:
                      <b
                        :class="
                          session.isCancelable ? 'text-success' : 'text-danger'
                        "
                      >
                        <i class="fi mdi-check" v-if="session.isCancelable"></i>
                        <i class="fi mdi-close" v-else></i>
                        {{ session.isCancelable ? 'بلی' : 'خیر' }}
                      </b>
                    </h6>
                  </div>
                  <div class="col-12" v-if="entityObject.sessionTypeID == 1">
                    <h6 :class="isMobile ? 'fs-8' : ''">
                      آدرس: <b>{{ session.centerName }}</b>
                    </h6>
                  </div>
                  <div
                    class="col-12"
                    v-if="getTariffPriceSessionCount(session) > 1"
                  >
                    <combo-box-with-message
                      ref="selectTariffPriceIDCombo"
                      warningSelectRow="نوع تعرفه جلسه را انتخاب نمایید"
                      :comboList="getTariffPriceBySessionID(session.sessionID)"
                      errorText="انتخاب تعرفه الزامی است"
                      :topTitleClass="isMobile ? 'smallerSelectInput' : ''"
                      itemKey="tariffPriceDetailID"
                      :required="true"
                      itemValue="title"
                      comboClass="text-end mt-1"
                      :selectAndOptionsClass="isMobile ? 'fs-8 ' : ''"
                      comboSize="sm"
                      :hasSideBox="false"
                      v-model:selectedItem="session.selectedTariffPriceDetailID"
                      topTitle="نوع تعرفه(قیمت جلسه):"
                    />
                  </div>
                  <div class="col-12 col-md-6" v-else>
                    <h6 :class="isMobile ? 'fs-8' : ''">
                      تعرفه:
                      <b
                        v-if="
                          sessionsTariffPriceList.length != 0 &&
                          getTariffPriceBySessionID(session.sessionID).length !=
                            0
                        "
                        >{{
                          getTariffPriceBySessionID(session.sessionID)[0].title
                        }}</b
                      >
                      <b v-else class="text-danger"
                        >برای این جلسه تعرفه تعریف نشده است.</b
                      >
                    </h6>
                  </div>
                  <div
                    class="text-bold text-danger"
                    v-if="
                      getTariffPriceBySessionID(session.sessionID)[0]
                        ?.tariffTypeID == 2
                    "
                  >
                    <i class="fi fi-close"></i>
                    جلسه غیرقابل لغو است.
                  </div>
                </div>
                <div class="d-flex justify-content-end">
                  <button
                    class="btn btn-sm btn-danger animate-pulse"
                    :class="isMobile ? 'p-1' : ''"
                    @click="
                      openConfirmationModal(
                        index,
                        session,
                        entityObject.personID,
                        entityObject.sessionTypeID,
                        entityObject.therapyTypeTitle
                      )
                    "
                  >
                    <svg
                      v-if="hasSessionToReplace()"
                      width="18px"
                      height="18px"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      class="bi bi-arrow-left-right"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M1 11.5a.5.5 0 0 0 .5.5h11.793l-3.147 3.146a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L13.293 11H1.5a.5.5 0 0 0-.5.5zm14-7a.5.5 0 0 1-.5.5H2.707l3.147 3.146a.5.5 0 1 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 4H14.5a.5.5 0 0 1 .5.5z"
                      ></path>
                    </svg>
                    <svg
                      v-else
                      width="24px"
                      height="24px"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      class="bi bi-check"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"
                      ></path>
                    </svg>

                    {{ hasSessionToReplace() ? 'جابجایی' : 'ثبت' }}
                  </button>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div v-else>
        <p class="mb-2" style="text-align: justify">
          در این بازه زمانی جلسه‌ای به منظور انتخاب وجود <b>ندارد</b>.
        </p>
      </div>
    </template>
    <template #footer> </template>
  </site-modal>
  <site-modal
    ID="toContinueConfirmationModal"
    modalSize="semiMedium"
    :modalHasFooter="true"
    @Closed="closedToContinueConfirmationModal"
  >
    <template #header>
      <div class="text-yellowTheme">
        <h6>
          <i class="fi fi-box-checked"></i>
          ادامه فرآیند
        </h6>
      </div>
    </template>
    <template #body>
      <div>
        <p>
          آیا تمایل دارید در همین «بازه زمانی» و از همین «درمانگر» جلسه دیگری را
          ثبت نمایید؟
        </p>
      </div>
    </template>
    <template #footer>
      <div class="d-flex w-100 justify-content-between">
        <button
          class="btn btn-sm btn-outline-blueSite"
          @click="yesToContinue()"
        >
          <svg
            width="18px"
            height="18px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-check-lg"
            viewBox="0 0 16 16"
          >
            <path
              d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"
            ></path>
          </svg>
          بلی
        </button>
        <button class="btn btn-sm btn-outline-danger" @click="noToContinue()">
          <svg
            width="18px"
            height="18px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-x-lg"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M13.854 2.146a.5.5 0 0 1 0 .708l-11 11a.5.5 0 0 1-.708-.708l11-11a.5.5 0 0 1 .708 0Z"
            ></path>
            <path
              fill-rule="evenodd"
              d="M2.146 2.146a.5.5 0 0 0 0 .708l11 11a.5.5 0 0 0 .708-.708l-11-11a.5.5 0 0 0-.708 0Z"
            ></path>
          </svg>
          خیر
        </button>
      </div>
    </template>
  </site-modal>
  <!-- <site-modal
    ID="reserveConfirmationModal"
    :modalSize="hasSessionToReplace() ? 'semiMedium' : 'small'"
    :modalHasFooter="true"
    @Closed="closedreserveConfirmationModal"
  >
    <template #header>
      <div class="text-yellowTheme">
        <h6>
          <i class="fi fi-box-checked"></i>
          {{ hasSessionToReplace() ? 'تایید جابجایی' : 'تایید ثبت' }}
        </h6>
      </div>
    </template>
    <template #body>
      <div v-if="sessionsList.length != 0">
        <p v-if="hasSessionToReplace()">
          از انتخاب این جلسه به منظور
          <span class="fw-bold text-danger-gradient blinkText"
            >جابجایی جلسه</span
          >
          اطمینان دارید؟
        </p>
        <p v-else class="mb-2" style="text-align: justify">
          آیا جزییات جلسه‌تان را به دقت چک کرده‌اید؟
        </p>
      </div>
    </template>
    <template #footer>
      <div class="d-flex w-100 justify-content-between">
        <button
          class="btn btn-sm btn-outline-blueSite"
          @click="
            reserveSession(
              selectedSessionForReserve.session,
              selectedSessionForReserve.personID,
              selectedSessionForReserve.sessionTypeID,
              selectedSessionForReserve.therapyTypeTitle
            )
          "
        >
          <svg
            width="18px"
            height="18px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-check-lg"
            viewBox="0 0 16 16"
          >
            <path
              d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"
            ></path>
          </svg>
          بلی
        </button>
        <button
          class="btn btn-sm btn-outline-danger"
          @click="closedreserveConfirmationModal()"
        >
          <svg
            width="18px"
            height="18px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-x-lg"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M13.854 2.146a.5.5 0 0 1 0 .708l-11 11a.5.5 0 0 1-.708-.708l11-11a.5.5 0 0 1 .708 0Z"
            ></path>
            <path
              fill-rule="evenodd"
              d="M2.146 2.146a.5.5 0 0 0 0 .708l11 11a.5.5 0 0 0 .708-.708l-11-11a.5.5 0 0 0-.708 0Z"
            ></path>
          </svg>
          خیر
        </button>
      </div>
    </template>
  </site-modal> -->
  <div
    class="p-0 scrollable-styled-dark"
    :style="isMobile ? '' : 'overflow: auto; height: 100%; max-height: 61vh'"
  >
    <table
      v-if="!isMobile"
      class="table table-bordered m-0"
      style="position: relative"
    >
      <thead style="position: sticky; top: 0; z-index: 2">
        <reserve-scheduling-header :dataList="headerList" />
      </thead>
      <tbody>
        <tr v-for="time in getShifts()" :key="time.id">
          <th scope="row" class="text-center align-middle fixColumn bg-blue">
            {{ time.title }}
          </th>
          <td
            v-for="(item, headerItemIndex) in headerList"
            :key="headerItemIndex"
            class="p-0 bg-lightsecondary"
          >
            <div
              v-if="findSessions(time.id, item.persianDate) != null"
              @click="selectCell(time.id, item.persianDate)"
              :ref="`cell${time.id}${item.englishDate}`"
              :id="`cell${time.id}${item.englishDate}`"
              class="w-100 h-100 box text-center text-white cell"
            >
              انتخاب
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <table
      v-if="isMobile"
      class="table table-bordered m-0 p-0"
      style="position: relative"
    >
      <thead style="position: sticky; top: 0; z-index: 2">
        <tr>
          <th
            rowspan="2"
            class="text-center bg-blue text-light align-middle fixColumn"
          >
            تاریخ
          </th>
          <th
            scope="col"
            class="text-center bg-blue text-light align-middle fixColumn"
            v-for="time in getShifts()"
            :key="time.id"
          >
            {{ time.title }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(day, index) in headerList" :key="index">
          <td
            scope="row"
            class="text-center align-middle fixColumn bg-blue p-0"
          >
            {{ day.dayName }}
            <small class="d-block">{{ day.persianDate }}</small>
            <small
              class="d-block gregorianDateClass"
              v-if="this.$store.getters.isOverseas"
              >{{ getGregorianDateOfSession(day.englishDate) }}</small
            >
          </td>
          <td class="p-0 bg-lightsecondary">
            <div
              v-if="findSessions(1, day.persianDate) != null"
              @click="selectCell(1, day.persianDate)"
              :ref="`cell${1}${day.englishDate}`"
              :id="`cell${1}${day.englishDate}`"
              class="w-100 h-100 box text-center text-white cell"
            >
              انتخاب
            </div>
          </td>
          <td class="p-0 bg-lightsecondary" v-if="isOnlineSessions">
            <div
              v-if="findSessions(2, day.persianDate) != null"
              @click="selectCell(2, day.persianDate)"
              :ref="`cell${2}${day.englishDate}`"
              :id="`cell${2}${day.englishDate}`"
              class="w-100 h-100 box text-center text-white cell"
            >
              انتخاب
            </div>
          </td>
          <td class="p-0 bg-lightsecondary">
            <div
              v-if="findSessions(3, day.persianDate) != null"
              @click="selectCell(3, day.persianDate)"
              :ref="`cell${3}${day.englishDate}`"
              :id="`cell${3}${day.englishDate}`"
              class="w-100 h-100 box text-center text-white cell"
            >
              انتخاب
            </div>
          </td>
          <td class="p-0 bg-lightsecondary" v-if="isOnlineSessions">
            <div
              v-if="findSessions(4, day.persianDate) != null"
              @click="selectCell(4, day.persianDate)"
              :ref="`cell${4}${day.englishDate}`"
              :id="`cell${4}${day.englishDate}`"
              class="w-100 h-100 box text-center text-white cell"
            >
              انتخاب
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import ReserveSchedulingHeader from '../header/reserveSchedulingHeader/ReserveSchedulingHeader.vue';
import LoadingSpinner from '../../../../components/utility/loadingSpinner/LoadingSpinner.vue';
import ComboBoxWithMessage from '../../../../components/form/comboBoxWithMessage/ComboBoxWithMessage.vue';
import { isMobile } from 'mobile-device-detect';
import { Modal } from 'bootstrap';
import axios from 'axios';
export default {
  components: {
    ReserveSchedulingHeader,
    LoadingSpinner,
    ComboBoxWithMessage,
  },
  data() {
    return {
      selectedSessionForReserve: {
        session: new Object(),
        personID: 0,
        sessionTypeID: 0,
        therapyTypeTitle: 0,
      },
      selectedTimeTable: '',
      isSessionListModalErrorShows: false,
      sessionListModalErrorMessage: '',
      isSessionListModalShown: false,
      isConfirmationModalShown: false,
      timeTableList: [],
      toContinueConfirmationModal: new Object(),
      // reserveConfirmationModal: new Object(),
      timesListModal: new Object(),
      sessionsListModal: new Object(),
      selectedCell: new Object({
        englishDate: '',
        groupedTimeTable: [],
        persianDate: '',
        timeType: 0,
        dayName: '',
      }),
      sessionsTariffPriceList: [],
      sessionsList: [
        {
          sessionID: 0,
          englishDate: '0000-00-00T00:00:00',
          persianDate: '0000/00/00',
          fromTime: '00:00:00',
          toTime: '00:00:00',
          therapistID: 0,
          therapistName: '',
          centerName: '',
          roomCode: '',
          isCancelable: false,
        },
      ],
      isMobile: isMobile,
    };
  },
  props: {
    headerList: {
      type: Array,
      default: new Array(),
    },
    siteClientReserveSessions: {
      type: Array,
      default: new Array(),
    },
    isOnlineSessions: {
      type: Boolean,
      required: true,
    },
    entityObject: {
      sessionTypeID: '1',
      educationID: null,
      genderID: null,
      therapistID: null,
      ageRangeID: null,
      therapyTypeID: null,
      therapyTypeTitle: '',
      scopeIDs: [],
      topicIDs: [],
      approachIDs: [],
      otherAbilityIDs: [],
      personID: 0,
      isOverseas: false,
      lockedTherapistID: null,
    },
  },
  inject: [
    'addSessionToSemiList',
    'semiReserveList',
    'semiReserveListCount',
    'hasSessionToReplace',
    'nextStep',
    'refreshTableWithTherapistFilter',
    'getBackRoutFrom',
  ],
  methods: {
    noToContinue() {
      this.lockedTherapistID = null;
      sessionStorage.removeItem('lockedTherapistID');
      this.closedToContinueConfirmationModal();
      window.scrollTo(0, document.body.scrollHeight);
    },
    closedToContinueConfirmationModal() {
      this.isSessionListModalErrorShows = false;
      this.isSessionListModalShown = false;
      this.isConfirmationModalShown = false;
      this.toContinueConfirmationModal.hide();
      this.timesListModal.hide();
    },
    yesToContinue() {
      sessionStorage.setItem('lockedTherapistID', this.lockedTherapistID);
      this.refreshTableWithTherapistFilter();
      this.timesListModal.hide();
      this.toContinueConfirmationModal.hide();
      this.isConfirmationModalShown = false;
      this.isSessionListModalShown = false;
    },
    async reserveSession(session, personID) {
      this.$refs.spinner.show();
      let tariffPriceDetailID;
      let that = this;
      //اگر چند تعرفه ای بود
      if (this.getTariffPriceSessionCount(session) > 1) {
        //اگر تعرفه انتخاب نشده بود
        if (
          !session.selectedTariffPriceDetailID ||
          session.selectedTariffPriceDetailID == 0
        ) {
          this.$refs.selectTariffPriceIDCombo[0].showErrorMessage();
          return;
        } else tariffPriceDetailID = session.selectedTariffPriceDetailID;
      } else
        tariffPriceDetailID = this.getTariffPriceDetailID(session.sessionID);
      let tariffPrice = that
        .getTariffPriceBySessionID(session.sessionID)
        .find((f) => f.tariffPriceDetailID == tariffPriceDetailID);
      if (this.semiReserveList().length > 0)
        if (
          !this.semiReserveList().some(
            (element) => element.currencyTypeID == tariffPrice.currencyTypeID
          )
        ) {
          // this.closedreserveConfirmationModal();
          this.sessionListModalErrorMessage =
            'به دلیل وجود نوع تعرفه متفاوت در لیست جلسات انتخاب شده شما، امکان انتخاب این جلسه با این تعرفه وجود ندارد.';
          this.isSessionListModalErrorShows = true;
          this.$refs.spinner.hide();
          this.$refs.notification.show({
            type: 'error',
            title: this.sessionListModalErrorMessage,
          });
          return;
        }
      if (that.hasSessionToReplace()) {
        that.addSessionToSemiList(
          new Object({
            sessionID: session.sessionID,
            personID,
            isCancelable: session.isCancelable,
            tariffPriceDetailID: tariffPriceDetailID,
            therapistName: session.therapistName,
            sessionTypeID: session.sessionTypeID,
            timeType: session.timeType,
            centerName: session.centerName,
            roomCode: session.roomCode,
            therapyTypeTitle: session.therapyTypeTitle,
            fromTime: session.fromTime,
            toTime: session.toTime,
            date: session.englishDate,
            tariffType: tariffPrice.tariffTypeTitle,
            tariffTypeID: tariffPrice.tariffType,
            price: tariffPrice.price,
            currencyTypeTitle: tariffPrice.currencyTypeTitle,
            currencyTypeID: tariffPrice.currencyTypeID,
            discountPercent: 0,
          })
        );
        that.closedSessionsListModal();
        // that.closedreserveConfirmationModal();
        that.closedTimesListModal();
        that.$refs.spinner.hide();
        that.nextStep(null, 'sessionTableView');
        return;
      }
      await axios
        .post('/CLC/Session/SetSemiReserveSessionForSite', {
          sessionID: session.sessionID,
          personID,
          isCancelable: session.isCancelable,
          tariffPriceDetailID,
        })
        .then((response) => {
          if (response.data.success) {
            that.$refs.notification.show({
              type: 'success',
              title: `جلسه مورد نظر در لیست جلسات به منظور رزرو قرار گرفت.`,
            });
            that.selectedCell.groupedTimeTable =
              that.selectedCell.groupedTimeTable.filter(
                (f) => f != that.selectedTimeTable
              );
            that.siteClientReserveSessions.find(
              (f) =>
                f.englishDate == that.selectedCell.englishDate &&
                f.timeType == that.selectedCell.timeType
            ).groupedTimeTable = that.siteClientReserveSessions
              .find(
                (f) =>
                  f.englishDate == that.selectedCell.englishDate &&
                  f.timeType == that.selectedCell.timeType
              )
              .groupedTimeTable.split('/')
              .filter((f) => f != that.selectedTimeTable)
              .join('/');

            //CurrencyTypeID
            that.addSessionToSemiList(
              new Object({
                sessionID: session.sessionID,
                personID,
                isCancelable: session.isCancelable,
                tariffPriceDetailID: tariffPriceDetailID,
                therapistName: session.therapistName,
                sessionTypeID: session.sessionTypeID,
                timeType: session.timeType,
                centerName: session.centerName,
                roomCode: session.roomCode,
                therapyTypeTitle: session.therapyTypeTitle,
                fromTime: session.fromTime,
                toTime: session.toTime,
                date: session.englishDate,
                tariffType: tariffPrice.tariffTypeTitle,
                tariffTypeID: tariffPrice.tariffType,
                price: tariffPrice.price,
                currencyTypeTitle: tariffPrice.currencyTypeTitle,
                currencyTypeID: tariffPrice.currencyTypeID,
                discountPercent: 0,
              })
            );

            if (that.getBackRoutFrom() == 'selectTestSession') {
              that.closedSessionsListModal();
              // that.closedreserveConfirmationModal();
              that.closedTimesListModal();
              that.$refs.spinner.hide();
              that.nextStep(null, 'sessionTableView');
              return;
            }
            that.closedSessionsListModal();
            // that.closedreserveConfirmationModal();
            that.isSessionListModalShown = true;
            that.reDesigneCells();

            if (
              !sessionStorage.getItem('lockedTherapistID') &&
              session.therapyTypeID != 2
            )
              that.toContinueConfirmationModal.show();
            else {
              that.toContinueConfirmationModal.hide();
              that.isSessionListModalShown = false;
              that.timesListModal.hide();
              window.scrollTo(0, document.body.scrollHeight);
            }
            //نگه داشتن شناسه درمانگر چنانچه کاربر بخواهد این روند را ادامه دهد
            that.lockedTherapistID = session.therapistID;
          } else
            that.$refs.notification.show({
              type: 'error',
              title: 'عملیات ثبت جلسه با خطا مواجه گردید',
            });
        })
        .catch((error) => {
          if (!error.response.data.success) {
            let errorMessages = error.response.data.errors.map(
              (i) => i.errorMessage
            );
            errorMessages.forEach((item) => {
              that.$refs.notification.show({
                type: 'error',
                title: item,
              });
            });
            if (errorMessages && errorMessages.length > 0) return;
          }
          that.$refs.notification.show({
            type: 'error',
            title: `عملیات ثبت جلسه با خطا مواجه گردید.`,
          });
        })
        .finally(() => {
          that.$refs.spinner?.hide();
        });
    },
    getTariffPriceSessionCount(session) {
      if (session.sessionID == 0 || this.sessionsTariffPriceList.length == 0)
        return 0;
      var tariffPriceList = this.getTariffPriceBySessionID(session.sessionID);
      if (tariffPriceList != undefined) return tariffPriceList.length;
      else return 0;
    },
    getTariffPriceBySessionID(sessionID) {
      if (sessionID == 0 || this.sessionsTariffPriceList.length == 0)
        return new Array();

      let tariffList = this.sessionsTariffPriceList.find(
        (f) => f.sessionID == sessionID
      )?.tariffPrice;
      //اگر در حالت جابجایی جلسه بود، نوع تعرفه این جلسه باید با نوع تعرفه جلسه جابجایی برابر باشد
      if (this.hasSessionToReplace())
        tariffList = tariffList.filter(
          (f) =>
            f.currencyTypeID ==
            this.$store.getters.replacedSessionData.currencyTypeID
        );
      return tariffList;
    },
    getTariffPriceDetailID(sessionID) {
      if (sessionID == 0) return;
      if (this.hasSessionToReplace()) {
        let allTariffPrices = this.sessionsTariffPriceList.find(
          (f) => f.sessionID == sessionID
        )?.tariffPrice;
        return allTariffPrices.find(
          (f) =>
            f.currencyTypeID ==
            this.$store.getters.replacedSessionData.currencyTypeID
        ).tariffPriceDetailID;
      }
      return this.sessionsTariffPriceList.find((f) => f.sessionID == sessionID)
        ?.tariffPrice[0].tariffPriceDetailID;
    },
    getPersianDate(date) {
      // eslint-disable-next-line
      return new persianDate(new Date(date)).format('L');
    },
    getHourAndMinute(data) {
      return `${data.split(':')[0]}:${data.split(':')[1]}`;
    },
    async getSessions(fromTime, toTime, englishDate, selectedItem) {
      this.selectedTimeTable = selectedItem;
      let that = this;
      let therapistID = this.entityObject.therapistID;

      //اگر کاربر بخواهد جلسه گرفتن با این درمانگر را ادامه دهد، فیلتر این درمانگر روی هفته ها اعمال شود
      if (sessionStorage.getItem('lockedTherapistID'))
        therapistID = sessionStorage.getItem('lockedTherapistID');
      that.$refs.spinner.show();
      await axios
        .post(
          '/CLC/Session/GetSiteSessionsList',
          new Object({
            englishDate: englishDate,
            fromTime: fromTime,
            toTime: toTime,
            sessionTypeID: that.entityObject.sessionTypeID,
            educationID: that.entityObject.educationID,
            genderID: that.entityObject.genderID,
            therapistID: therapistID,
            ageRangeID: that.entityObject.ageRangeID,
            therapyTypeID: that.entityObject.therapyTypeID,
            scopeIDs: that.entityObject.scopeIDs,
            topicIDs: that.entityObject.topicIDs,
            approachIDs: that.entityObject.approachIDs,
            otherAbilityIDs: that.entityObject.otherAbilityIDs,
            personID: that.entityObject.personID,
            isOverseas:
              that.entityObject.isOverseas ?? that.$store.getters.isOverseas,
          })
        )
        .then(async (response) => {
          that.sessionsList = response.data;
          if (that.sessionsList.length == 0) {
            that.isSessionListModalShown = true;
            that.sessionsListModal.show();
            return;
          }
          let modelAPI = new Array();
          that.sessionsList.forEach((element) => {
            modelAPI.push(
              Object.assign(
                {},
                {
                  sessionID: element.sessionID,
                  therapyTypeID:
                    that.entityObject.therapyTypeID ??
                    response.data[0].therapyTypeID,
                  sessionTypeID: that.entityObject.sessionTypeID,
                  personID: that.entityObject.personID,
                }
              )
            );
          });
          //اگر جلسه ای بود، اقدام به دریافت تعرفه کند
          if (response.data.length > 0) {
            await axios
              .post('/CLC/Session/GetSessionsTariffPriceForSite', modelAPI)
              .then((response) => {
                that.sessionsTariffPriceList = response.data;
                that.isSessionListModalShown = true;
                that.sessionsListModal.show();
              })
              .catch(() => {
                that.$refs.notification.show({
                  type: 'error',
                  title: `عملیات با خطا مواجه گردید`,
                });
              });
          }
        })
        .catch(() => {
          that.$refs.notification.show({
            type: 'error',
            title: `عملیات با خطا مواجه گردید`,
          });
        })
        .finally(() => {
          that.$refs.spinner.hide();
        });
    },
    getGregorianDateOfSession(date) {
      // eslint-disable-next-line
      return getGregorianDate(date);
    },
    findSessions(timeTypeID, persianDate) {
      let session = null;
      session = this.siteClientReserveSessions.find(
        (f) => f.persianDate == persianDate && f.timeType == timeTypeID
      );
      return session;
    },
    async selectCell(timeTypeID, persianDate) {
      let session = null;
      session = this.findSessions(timeTypeID, persianDate);
      this.selectedCell.englishDate = session.englishDate;

      if (session.groupedTimeTable != '')
        this.selectedCell.groupedTimeTable =
          session.groupedTimeTable.split('/');
      this.selectedCell.persianDate = session.persianDate;
      this.selectedCell.timeType = session.timeType;
      this.selectedCell.dayName = this.headerList.find(
        (f) => f.persianDate == session.persianDate
      ).dayName;
      this.timesListModal.show();
    },
    getShiftByTimeType(timeTypeId) {
      let shiftText = '';
      switch (timeTypeId) {
        case 1:
          shiftText = 'صبح';
          break;
        case 2:
          shiftText = 'ظهر';
          break;
        case 3:
          shiftText = 'عصر';
          break;
        case 4:
          shiftText = 'شب';
          break;
      }
      return shiftText;
    },
    getShifts() {
      if (this.isOnlineSessions) {
        return [
          { id: 1, title: 'صبح' },
          { id: 2, title: 'ظهر' },
          { id: 3, title: 'عصر' },
          { id: 4, title: 'شب' },
        ];
      } else
        return [
          { id: 1, title: 'صبح' },
          { id: 3, title: 'عصر' },
        ];
    },
    getSiteClientReserveSessions() {
      return this.siteClientReserveSessions;
    },
    getFromTime(item) {
      return item.split('-')[0];
    },
    getToTime(item) {
      return item.split('-')[1];
    },
    closedTimesListModal() {
      this.timesListModal.hide();
    },
    openConfirmationModal(
      index,
      session,
      personID,
      sessionTypeID,
      therapyTypeTitle
    ) {
      if (this.getTariffPriceSessionCount(session) == 0) {
        this.$refs.notification.show({
          type: 'error',
          title: 'برای جلسه مورد نظر تعرفه تعریف نشده است',
        });
        return;
      }
      if (
        this.getTariffPriceSessionCount(session) > 1 &&
        session.selectedTariffPriceDetailID == undefined
      ) {
        this.$refs.selectTariffPriceIDCombo[index].showErrorMessage();
        this.$refs.selectTariffPriceIDCombo[index].setFocus();
        return;
      }
      this.selectedSessionForReserve.session = session;
      (this.selectedSessionForReserve.personID = personID),
        (this.selectedSessionForReserve.sessionTypeID = sessionTypeID);
      this.selectedSessionForReserve.therapyTypeTitle = therapyTypeTitle;
      this.isConfirmationModalShown = true;
      // this.reserveConfirmationModal.show();
      this.reserveSession(
        this.selectedSessionForReserve.session,
        this.selectedSessionForReserve.personID,
        this.selectedSessionForReserve.sessionTypeID,
        this.selectedSessionForReserve.therapyTypeTitle
      );
    },
    closedSessionsListModal() {
      this.sessionsListModal.hide();
      this.isSessionListModalShown = false;
      this.isSessionListModalErrorShows = false;
      this.sessionListModalErrorMessage = '';
      this.sessionsTariffPriceList = [];
    },
    // closedreserveConfirmationModal() {
    //   this.isConfirmationModalShown = false;
    //   this.reserveConfirmationModal.hide();
    // },
    reDesigneCells() {
      if (this.semiReserveListCount != 0) {
        let semiList = this.semiReserveList();
        semiList.forEach((item) => {
          let elemnt = document.getElementById(
            'cell' + item.timeType + item.date
          );
          if (elemnt) elemnt.classList.add('reservedBackColor');
        });
      }
    },
  },
  mounted() {
    this.sessionsListModal = new Modal(
      document.getElementById('sessionsListModal'),
      {
        keyboard: false,
        backdrop: 'static',
      }
    );
    this.toContinueConfirmationModal = new Modal(
      document.getElementById('toContinueConfirmationModal'),
      {
        keyboard: false,
        backdrop: 'static',
      }
    );
    this.timesListModal = new Modal(document.getElementById('timesListModal'), {
      keyboard: false,
      backdrop: 'static',
    });

    // this.reserveConfirmationModal = new Modal(
    //   document.getElementById('reserveConfirmationModal'),
    //   {
    //     keyboard: false,
    //     backdrop: 'static',
    //   }
    // );
    this.reDesigneCells();
  },
  beforeMount() {
    // اگر مقادیر فیلتر ناقص بود به اولین تب برگردد
    if (this.entityObject.sessionTypeID == null) {
      this.$router.push({
        name: 'selectTherapist',
        id: this.$store.getters.userPersonID,
      });
    }
  },
};
</script>

<style scoped>
.timeItem {
  cursor: pointer;
  /* background-color: #465464;
  color: white !important; */
  background: linear-gradient(
      70deg,
      #0000 30%,
      rgba(255, 255, 255, 0.486) 50%,
      #0000 66%
    )
    #ffffff;
  background-size: 500% 300%;
  color: #465464 !important;
  transition: 0.5s;
  box-shadow: 1px 1px 5px #465464;
}
.timeItem:hover {
  background-color: #f7ca58;
  color: white !important;
  animation: shine 3s infinite;
  border-color: #f7ca58;
}
.w-45 {
  width: 45%;
}
.cell {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
}
.shine {
  background: #4c5e74;
}
.box {
  cursor: pointer;
  height: 50px;
  background: linear-gradient(
      70deg,
      #0000 30%,
      rgba(255, 255, 255, 0.486) 50%,
      #0000 66%
    )
    #ffffff;
  background-size: 500% 300%;
  color: #465464 !important;
  transition: 0.1s;
}
.box:hover {
  box-shadow: 3px 3px 5px rgb(39, 39, 39);
  text-shadow: 1px 1px 10px #f5f5f5;
  animation: shine 3s infinite;
  background-color: #f7ca58;
  color: white !important;
}
.box:active {
  background: #ca9100;
}
.reservedBackColor {
  background-color: rgb(255, 238, 0) !important;
}
.reservedBackColor:hover {
  color: black !important;
}
@keyframes shine {
  0% {
    background-position: right;
  }
}

table tbody tr td {
  /* display: block; */
  height: 50px !important;
  border-style: dashed;
  border-width: 2px;
}
table thead tr th {
  width: 150px !important;
}
.fixColumn {
  z-index: 1;
  position: sticky;
  right: 0px;
  /* background-color: #f7ca58; */
  color: #f3f4f6;
}
table {
  border-color: #4c5e7494;
}
.bg-lightsecondary {
  background-color: rgb(218, 218, 218);
}
</style>

<style>
.smallerSelectInput > h6 {
  font-size: 0.8rem;
}
.hideModal {
  transition: opacity 0.5s;
  opacity: 0.1;
}
.showModal {
  opacity: 1;
}
.modal-footer {
  padding: 5px 10px;
}
</style>
